module.exports = __webpack_public_path__ + "static/media/avatar.625b6e01.svg";